module.exports = __webpack_public_path__ + "assets/img/main-logo-hengshui.4c388933.png";